import API from "../../axios.jsx";

const BASE = "/bac";
const BASE_LISTAS = "/lista_bac";

export const subirFotoVivienda = (formData) =>
  API.post(`${BASE}/foto`, formData, { headers: { "Content-Type": "multipart/form-data" } });

export const adjuntarFotoAVisita = (codigoVivienda, { foto_url, foto_nombre }) =>
  API.put(`${BASE}/foto/${codigoVivienda}`, { foto_url, foto_nombre });

export const adjuntarFotoCarnet = (codigoVivienda, numeroIdentificacion, campo, { foto_url, foto_nombre }) =>
  API.put(`${BASE}/pai/carnet-foto/${codigoVivienda}`, { numero_identificacion: numeroIdentificacion, campo, foto_url, foto_nombre });

export const getVisitasBac         = (params) => API.get(BASE, { params });
export const getHistorialVivienda  = (codigoVivienda) => API.get(`${BASE}/historial/${codigoVivienda}`);
export const getPendientesRevisita = (params) => API.get(`${BASE}/pendientes-revisita`, { params });
export const getPaiVacunacion      = (params) => API.get(`${BASE}/pai`, { params });
export const exportarBarridoPai    = (params) => API.get(`${BASE}/pai/exportar`, { params, responseType: "blob" });
export const completarPersonaPai   = (paiId, datos) => API.put(`${BASE}/pai/${paiId}/completar-persona`, datos);
export const editarPaiVacunacion   = (paiId, datos) => API.put(`${BASE}/pai/${paiId}`, datos);
export const activarMatrizAutomatica = (paiId) => API.put(`${BASE}/pai/${paiId}/activar-matriz-automatica`);
export const eliminarPaiVacunacion = (paiId) => API.delete(`${BASE}/pai/${paiId}`);
export const createVisitaBac       = (payload) => API.post(BASE, payload);
export const updateVisitaBac       = (id, payload) => API.put(`${BASE}/${id}`, payload);
export const deleteVisitaBac       = (id) => API.delete(`${BASE}/${id}`);
export const exportarVisitasBac    = (params) => API.get(`${BASE}/exportar`, { params, responseType: "blob" });

// Catálogos (entrevistadores, líderes BAC, etnias, tipo de documento, etc.)
export const getCatalogo = (tipo) => API.get(`${BASE_LISTAS}/${tipo}`);

// Territorio / Comunidad — tabla relacional real, la comunidad se filtra
// según el territorio elegido.
export const getTerritorios = () => API.get(`${BASE_LISTAS}/territorios`);
export const getComunidadesDe = (territorio) => API.get(`${BASE_LISTAS}/comunidades`, { params: { territorio } });
// Excel con el filtro de la tabla aplicado (lista de filas por POST).
// tipo: "visitas" | "pai" | "mrcv"
export const exportarFiltradoBac = (tipo, body) =>
  API.post(`${BASE}/exportar-filtrado/${tipo}`, body, { responseType: "blob" });
